import { createIcon } from "../IconFactory";

export const CommercialIcon = createIcon('commercial');
export const ManLockedIcon = createIcon('manLocked');
export const ManCry = createIcon('manCry');
export const ManIcon = createIcon('man');
export const WomanIcon = createIcon('woman');
export const ProCreditIcon = createIcon('proCredit');
export const CreditIcon = createIcon('credit');
export const NewProjectStarIcon = createIcon('newProjectStar');
export const HousePercentageIcon = createIcon('housePercentage');
export const BankIcon = createIcon('bank');
export const BrokerRenegotiationIcon = createIcon('brokerRenegotiation');
export const UsersGroupIcon = createIcon('usersGroup');
export const DropdownChevronIcon = createIcon('dropdownChevron');
export const UmbrellaIcon = createIcon('umbrella');
export const UserCircleCheckIcon = createIcon('userCircleCheck');
export const BellIcon = createIcon('bell');
export const Filter = createIcon('filter');
export const ReceiptText = createIcon('receiptText');
export const HouseContract = createIcon('houseContract');
export const DatePickerIcon = createIcon('datepicker');
export const ExclamationPointIcon = createIcon('exclamationPoint');
export const MessageQuestionMark = createIcon('messageQuestionMark');
